<ng-container *ngIf="schema && show">
    <button nbButton [size]="schema.size" [shape]="schema.shape" [status]="schema.status"
        [disabled]="schema.disabled ? schema.disabled : undefined" [fullWidth]="schema.fullWidth ? true : undefined"
        [hero]="schema.appearance === 'colorful'" [outline]="schema.appearance === 'outline'"
        [ghost]="schema.mode === 'icon' || schema.appearance === 'basic'" (click)="clickEvent($event)"
        [nbTooltip]="schema.tooltip" [nbTooltipDisabled]="!schema.tooltip">
        <!-- text mode -->
        <ng-container *ngIf="!schema.mode || schema.mode === 'text'">{{schema.text}}</ng-container>
        <!-- icon before text  mode-->
        <ng-container *ngIf="schema.mode === 'iconBeforeText'">
            <icon-widget [icon]="schema.icon"></icon-widget>
            {{schema.text}}
        </ng-container>
        <!-- icon after text  mode-->
        <ng-container *ngIf="schema.mode === 'iconAfterText'">
            {{schema.text}}
            <icon-widget [icon]="schema.icon"></icon-widget>
        </ng-container>
        <!-- icon button or icon mode -->
        <ng-container *ngIf="schema.mode === 'iconButton' || schema.mode === 'icon'">
            <icon-widget [icon]="schema.icon"></icon-widget>
        </ng-container>
    </button>

</ng-container>